<template>
    <CardShell>
        <div class="pv3 ph3 bg-near-white bb b--light-gray">
            <h5 class="mt1">Owner</h5>
        </div>
        

        <div class="ph3 pv3">
            <OwnerRatingBar :owner="owner"/>
            <!-- <div class="pv3">
            <OwnerStat class="mb1" description="The location is determined by etc." title="Location">Within {{owner.distance}} KM</OwnerStat>
            <OwnerStat class="mb1" title="Response rate">{{owner.responseRate}}%</OwnerStat>
            <OwnerStat title="Response Time">{{owner.responseTime}}</OwnerStat>
            </div> -->
            <BlackButton class="mt4" @click="showWarning = true">Ask a question</BlackButton>
           

            <OverlayWarning :showWarning="showWarning">
                <AskQuestion
                    :ownerId="owner.id"
                    @cancel="showWarning = false"/>
            </OverlayWarning>
        </div>


    </CardShell>
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import OwnerRatingBar from '@/components/rent/listingDetail/ownerCard/OwnerRatingBar.vue';
import OwnerStat from '@/components/rent/listingDetail/ownerCard/OwnerStat.vue';
import BlackButton from '@/components/buttons/BlackButton.vue';
import OverlayWarning from '@/components/global/OverlayWarning.vue';
import AskQuestion from '@/components/rent/listingDetail/ownerCard/AskQuestion.vue';

export default {
    props: {
        showWarning: false,
        owner: {
            type: Object,
            required: true
        }
    },
    components: {
        CardShell,
        OwnerRatingBar,
        OwnerStat,
        BlackButton,
        OverlayWarning,
        AskQuestion
    }
};
</script>
